import produce from 'immer'
import { assign, get, set } from 'lodash'

import { DICTIONARY_WORD_TYPES } from '../../constants'
import {
  CREATE_DICTIONARY_WORDS_FOR_TYPE,
  TRANSFER_DICTIONARY_WORD_TO_INGREDIENT,
} from '../action-types'

const dictionaryWordModalsReducer = (state, action) => {
  switch (action.type) {
    case CREATE_DICTIONARY_WORDS_FOR_TYPE.START:
      return produce(state, nextState => {
        const typeFieldName = get(
          DICTIONARY_WORD_TYPES,
          `${action.payload.type}.fieldName`,
        )

        return assign(
          nextState,
          set(nextState, `data.${typeFieldName}`, {
            ...get(nextState, `data.${typeFieldName}`, {}),
            isLoading: true,
            error: undefined,
          }),
        )
      })

    case CREATE_DICTIONARY_WORDS_FOR_TYPE.COMPLETE:
      return produce(state, nextState => {
        const typeFieldName = get(
          DICTIONARY_WORD_TYPES,
          `${action.payload.variables.type}.fieldName`,
        )

        return assign(
          nextState,
          set(nextState, `data.${typeFieldName}`, {
            data: action.payload.data.createDictionaryWordsForType,
            isLoading: false,
            error: undefined,
          }),
        )
      })

    case CREATE_DICTIONARY_WORDS_FOR_TYPE.FAIL:
      return produce(state, nextState => {
        const typeFieldName = get(
          DICTIONARY_WORD_TYPES,
          `${action.payload.type}.fieldName`,
        )

        const { graphQLErrors, message } = action.error

        const errorDetails = get(
          graphQLErrors,
          '[0].extensions.exception.duplicated',
        )

        return assign(
          nextState,
          set(nextState, `data.${typeFieldName}`, {
            ...get(nextState, `data.${typeFieldName}`, {}),
            isLoading: false,
            error: {
              errorDetails,
              message,
            },
          }),
        )
      })

    case TRANSFER_DICTIONARY_WORD_TO_INGREDIENT.START:
      return produce(state, nextState => {
        const typeFieldName = get(
          DICTIONARY_WORD_TYPES,
          `${action.payload.filters.type}.fieldName`,
        )

        return assign(
          nextState,
          set(nextState, `data.${typeFieldName}`, {
            ...get(nextState, `data.${typeFieldName}`, {}),
            isLoading: true,
            error: undefined,
          }),
        )
      })

    case TRANSFER_DICTIONARY_WORD_TO_INGREDIENT.COMPLETE:
      return produce(state, nextState => {
        const typeFieldName = get(
          DICTIONARY_WORD_TYPES,
          `${action.payload.variables.filters.type}.fieldName`,
        )

        return assign(
          nextState,
          set(nextState, `data.${typeFieldName}`, {
            data: action.payload.data.transferDictionaryWordToIngredient,
            isLoading: false,
            error: undefined,
          }),
        )
      })

    case TRANSFER_DICTIONARY_WORD_TO_INGREDIENT.FAIL:
      return produce(state, nextState => {
        const typeFieldName = get(
          DICTIONARY_WORD_TYPES,
          `${action.payload.filters.type}.fieldName`,
        )

        const { graphQLErrors, message } = action.error

        const errorDetails = get(
          graphQLErrors,
          '[0].extensions.exception.duplicated',
        )

        return assign(
          nextState,
          set(nextState, `data.${typeFieldName}`, {
            ...get(nextState, `data.${typeFieldName}`, {}),
            isLoading: false,
            error: {
              errorDetails,
              message,
            },
          }),
        )
      })

    default:
      return state
  }
}

export default dictionaryWordModalsReducer
